export const environment = {
  production: true,

  firebase: {
    apiKey: 'AIzaSyBinnusP2NMqE6HexLe68GtaWGP-iyeXvI',
    authDomain: 'onecontrol-cloud-pilomat.firebaseapp.com',
    // databaseURL: '<your-database-URL>',
    projectId: 'onecontrol-cloud-pilomat',
    storageBucket: "onecontrol-cloud-pilomat.appspot.com",
    messagingSenderId: '140736632476',
    webPushCert: 'BClpmZXIRpiuLTcmcZOZ7sVOICofSGVmjYAvsXKF4PXtw0HM2Gy8JjXwr7t9IaUrNjFlEF2U3MN561yeRWaMsEU',
    appId: "1:140736632476:web:e4fca8d8ccefb67e7cff59",
    measurementId: "G-H1FT4VBSZ7"
  },

  google: {
    // TODO
    trakingId: 'UA-67436842-3'
  },

  onecontrol: {
    serverFolder: "pilomat",
    // serverFolder: "pilomatdev",
    apiUrl: "https://onecontrol-cloud-pilomat.appspot.com/_ah/api/webAdmin/v1/",
    apiKey: "AIzaSyC1Bcx9szW8CCHu2xmSrZeKuAiUn2F0XhI",
    versionCode: 34,
    // version: "3.0 dev",
    version: "3.2.3",
    // da fare toggle in base alle esigenze
    logEnabled: false,
    // logEnabled: true,
    firebaseDomain: "https://pilomat.page.link",
    context: "Pilomat",
    appName: "Pilomat",
    androidPackageName: "it.pilomat.app.and",
    iosBundleIdentifier: "it.pilomat.app.ios",
  }
};


// var firebaseConfig = {
//   apiKey: "AIzaSyBinnusP2NMqE6HexLe68GtaWGP-iyeXvI",
//   authDomain: "onecontrol-cloud-pilomat.firebaseapp.com",
//   projectId: "onecontrol-cloud-pilomat",
//   storageBucket: "onecontrol-cloud-pilomat.appspot.com",
//   messagingSenderId: "140736632476",
//   appId: "1:140736632476:web:e4fca8d8ccefb67e7cff59",
//   measurementId: "G-H1FT4VBSZ7"
// };
